import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const IMG =
  "https://images.pexels.com/photos/6196223/pexels-photo-6196223.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section
      id="why"
      className="relative py-24 md:py-32 bg-neutral-50 border-t border-black/10"
      data-testid="why-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Sticky heading + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <p className="text-[#1478FF] font-semibold tracking-[0.28em] uppercase text-xs mb-5">
                  {t.why.eyebrow}
                </p>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="font-display font-semibold text-neutral-900 text-4xl md:text-6xl tracking-tight leading-[0.95]">
                  {t.why.titleL1}
                  <br />
                  {t.why.titleL2}
                  <span className="text-[#1478FF]">{t.why.titleAccent}</span>
                </h2>
              </Reveal>
              <Reveal delay={0.12}>
                <div className="mt-8 relative h-64 w-full overflow-hidden border border-black/10">
                  <img
                    src={IMG}
                    alt="Detailed commercial cleaning"
                    className="h-full w-full object-cover grayscale-[0.2]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Numbered chapters */}
          <div className="lg:col-span-7 divide-y divide-black/10 border-t border-black/10">
            {t.why.items.map((w, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-70px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="group flex gap-6 md:gap-10 py-8 md:py-10"
                data-testid={`why-item-${i}`}
              >
                <span className="font-display text-2xl md:text-3xl font-medium text-neutral-400 group-hover:text-[#1478FF] transition-colors duration-300 shrink-0 w-12">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-2xl md:text-3xl text-neutral-900 tracking-tight">
                    {w.t}
                  </h3>
                  <p className="mt-2 text-neutral-600 text-sm md:text-base max-w-md leading-relaxed">
                    {w.d}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
